import urls from "api/urls";
import LeaftechLogoSidebar from "Asset/Images/leaftechLLg.svg";
import leaftechNavLooperBG from "Asset/Images/NavLooperBG.png";
import LeaftechLogoMain from "Asset/LEAFTECH.svg";
import LooperBGCropped from "Asset/LooperBGCropped.png";
import LooperBGLg from "Asset/LooperBGLg.png";
import { defaultLoginLayout } from "design-system/strategies/loginLayout";

export const leaftechTheme = {
  clientDisplayName: "LeafTech",

  favicon: "/leaftechFavicon.svg",

  fonts: {
    heading: "Exo 2",
    primary: "Nunito Sans",
  },

  links: {
    website: urls.redirects.leaftechWebsite,
  },

  login: {
    layout: defaultLoginLayout,
    logo: undefined,
    particles: undefined,
  },

  logo: {
    alt: "LeafTech",
    href: urls.redirects.leaftechWebsite,
    mainSrc: LeaftechLogoMain,
    sidebarSrc: LeaftechLogoSidebar,
  },

  logoLooper: {
    croppedSrc: LooperBGCropped,
    lgSrc: LooperBGLg,
  },

  name: "leaftech",

  navLooper: {
    src: leaftechNavLooperBG,
  },
};
